import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../../../components/PPMobileCardView';

const DoctorNoteItemMobile = ({ data, onCompleted, onEdit, onDelete }) => {
    const rows = [
        { label: 'Notes', value: data.notes, fullWidth: true },
        { label: 'Completion Date', value: data.completionDate.Valid ? moment(data.completionDate.Time).format("DD-MM-YYYY") : '-' },
    ];

    const menuItems = [
        { label: 'Completed Date', onClick: onCompleted },
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={`${data.batchName}(${data.shedName})`}
            rows={rows}
            // Same as desktop: no actions once the item is completed
            menuItems={data.completionDate.Valid ? undefined : menuItems}
        />
    );
};

export default DoctorNoteItemMobile;
